import { hostBridge } from '@publicala/delfino';
import type { SessionExpiredPayload } from '@publicala/delfino';
import type { VuexStore } from '../types';

let sessionStore: VuexStore | null = null;

/**
 * Configure dependencies for session commands.
 *
 * @param store - Vuex store
 */
export function configureSessionCommands(store: VuexStore): void {
    sessionStore = store;
}

/**
 * Register session commands that Volpe implements.
 * The Host calls these methods.
 */
export function registerSessionCommands(): void {
    if (!sessionStore) {
        console.warn('[SessionCommands] store not configured. Call configureSessionCommands first.');
        return;
    }

    const store = sessionStore;

    hostBridge.registerSessionCommands({
        /**
         * Handle session expiration notification from host.
         *
         * @param payload - Expiration details
         */
        sessionExpired: async (_payload: SessionExpiredPayload): Promise<void> => {
            store.dispatch('showSessionExpiredModal');
        },
    });
}
